import styled from "styled-components";
import { Colors } from "../../shared/colors/colors";

export const DropdownDivider = styled.div`
  border: 1px solid ${Colors.borderMenu};
  width: 100%;
  margin-top: 11px;
  margin-bottom: 0px;
`;

export const DropdownScroll = styled.div`
  overflow-y: auto;
  max-height: 300px;
`;